import { LitElement, html, css } from "lit-element";
import "@stofloos/components/atoms/inputs/json-editor";
import "@stofloos/components/molecules/forms/sw-form";
import { style } from "./style";

// language=CSS
export const StofwareFormEditorStyle = css`
	:host {
		display: inline-block;
		padding: 0 0 70px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		position: relative;
	}

	[contenteditable="true"]:focus {
		outline: none;
	}

	input-textarea {
		width: 100%;
	}

	button {
		background: none;
		border: none;
		cursor: pointer;
		height: 24px;
		padding: 3px 5px;
		margin: 0 5px;
		width: 28px;
		color: var(--app-primary);
		font-size: 14px;
	}

	button:hover {
		color: var(--app-accent);
	}

	.w-100 {
		width: 100%;
	}
`;

export class StofwareFormEditor extends LitElement {
	static get properties() {
		return {
			name: { type: String },
			label: { type: String },
			class: { type: String },
			editor: { type: Object },
			data: { type: Object },
			html: { type: Object },
			required: { type: Boolean },
			disabled: { type: Boolean }
		};
	}

	firstUpdated(_changedProperties) {
		super.firstUpdated(_changedProperties);
	}

	updated(_changedProperties) {
		super.updated(_changedProperties);
	}

	static get styles() {
		return [style, StofwareFormEditorStyle];
	}

	render() {
		return html`
			<div class="layout horizontal">
				<json-editor
					label="${this.label}"
					name="${this.name}"
					.data="${this.data}"
					class="form-section ${this.class}"
				></json-editor>
				<sw-form .config="${this.data}"></sw-form>
			</div>
		`;
	}
}

customElements.define("form-editor", StofwareFormEditor);
